import { merge } from 'lodash';
import { StylePanelAsync, EventPanelAsync } from '@goodt-wcore/panels';

import { DATASET_PROP, DATASET_QUERY_LIMIT_DEFAULT, DEVIATIONS_PROP } from '../consts';
import { useDatasetPanels, VariablePanelAsync, DeviationsPanelAsync } from '../panels';

import { queryCreateFromRequestProps } from './query-utils';
import { DeviationsLabelMap, DeviationsHintMap } from './deviation-const';

/**
 * @param {{ name:string, dataProviderId:string|number }}
 * @returns {import('../types').IDatasetRequestProps}
 */
export const createDataset = ({ name = '', datasetName = name, dataProviderId = null, query, limit = DATASET_QUERY_LIMIT_DEFAULT } = {}) => ({
    name,
    datasetName,
    dataProviderId,
    query: queryCreateFromRequestProps({ query }),
    limit
});

/**
 * @param {{ name: string }}
 * @return {import('../types').IDeviationRule}
 */
const createDeviationRule = ({ name = '' }) => ({
    name,
    formula: ''
});

/** @return {import('../types').IDeviationDatasetProps} */
const createDeviationDatasetProps = () => ({
    index: null,
    key: null
})

/**
 *
 * @param {Record<string, any>} meta
 * @param {?string} [prop]
 * @param {boolean} [deviations = false]
 * @param {import('./elem-utils').IDatasetPanelOptions|false} [panel={}]
 * @return {Record<string, any>}
 */
export const useDatasetMeta = (meta, {
    prop = DATASET_PROP,
    deviations = false,
    panel = {}
} = {}) => ({
    ...meta,
    panels: [
        ...(panel === false
            ? []
            : useDatasetPanels({
                prop,
                ...panel
            })
        ),
        ...(deviations === false
            ? []
            : [
                DeviationsPanelAsync
            ]),
        ...(meta.panels ?? [])
    ],
    panelsDefault: [
        StylePanelAsync,
        EventPanelAsync,
        VariablePanelAsync
    ],
    descriptor: () =>
        merge(
            {
                props: {
                    [prop]: {
                        type: Array,
                        default: () => [],
                        options: {
                            create: createDataset
                        }
                    },
                    ...(deviations && {
                        /** @type {import('vue').PropOptions<import('../types').IDeviations>} */
                        [DEVIATIONS_PROP]: {
                            type: Object,
                            default: () => ({
                                refDatasetIndex: null,
                                refDatasetKey: null,
                                datasets: [],
                                rules: []
                            }),
                            options: {
                                createRule: createDeviationRule,
                                createDatasetProps: createDeviationDatasetProps
                            },
                            label: DeviationsLabelMap,
                            hint: DeviationsHintMap
                        }
                    })
                }
            },
            meta.descriptor?.() ?? {}
        )
});
